import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=5787c4d0&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "../assets/style/footer.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports